import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import SettingsListLayer from "../components/SettingsListLayer";

const SettingsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle='Application Settings'>
        {/* Breadcrumb */}
        <SettingsListLayer />
      </MasterLayout>
    </>
  );
};

export default SettingsPage;
